export default __webpack_public_path__ + "static/media/case_study_4.93900ffb.jpg";